module.exports = __webpack_public_path__ + "img/earth-europa.91169be0.svg";